"use client";

import { isFogEnabledForPath } from "@/app/(landing)/lander.client";
import Logo from "@/components/marketing-logo";
import { INTERNAL_LINKS } from "@/lib/helpers/urls";
import { cn } from "cn";
import dynamic from "next/dynamic";
import Link from "next/link";
import { usePathname } from "next/navigation";

export const BaseLogo = (
  props: Omit<React.ComponentProps<typeof Link>, "className" | "href">,
) => {
  const path = usePathname();

  return (
    <div className="p-0 m-0 border-0 bg-transparent relative size-[28px]">
      <Link
        href={INTERNAL_LINKS.HOME}
        className="focus:outline-none hover:underline inline-block"
        {...props}
      >
        <Logo
          className={cn(
            "",
            isFogEnabledForPath(path) ? "invert" : "grayscale opacity-60",
          )}
          sizePx={28}
        />
      </Link>
    </div>
  );
};

const PressKitPopover = dynamic(
  () =>
    import("./components.lazy.client").then((mod) => ({
      default: mod.PressKitPopover,
    })),
  {
    ssr: false,
    loading: () => <BaseLogo />,
  },
);

export const LogoWithPressKit = () => {
  const path = usePathname();

  return (
    <PressKitPopover>
      <Logo
        className={
          isFogEnabledForPath(path) ? "invert" : "grayscale opacity-60"
        }
        sizePx={28}
      />
    </PressKitPopover>
  );
};
